"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPlaceHolder = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var avatars_1 = require("components/Avatar/avatars");
var classNames = require("classnames");
require("./styles.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)((0, translation_1.getLocalization)('notFound')), recompose_1.pure);
exports.NotFoundPlaceHolder = enhance(function (props) { return (React.createElement("div", { key: props.key ? props.key : 'not-found-message', className: classNames('not-found-message', props.className) },
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(props.avatar ? props.avatar : 'Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)(props.title)),
    props.message && React.createElement("span", null, (0, translation_1.getLocalization)(props.message)),
    props.message2 && React.createElement("span", null, (0, translation_1.getLocalization)(props.message2)))); });
